import { FC, ReactElement } from 'react'

import EmploymentTypeBadgeFilter from '../../../../components/Filters/subcomponents/EmploymentTypeBadgeFilter/EmploymentTypeBadgeFilter'
import { setShowEmploymentTypes } from '../../../redux/@interface/globalFilters/globalFiltersReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'

const ConnectedEmploymentTypeBadgeFilter: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const showEmploymentTypes = useTypedSelector(state => state.globalFiltersReducer.showEmploymentTypes)

    const handleChange = (show: boolean): void => {
        dispatch(setShowEmploymentTypes(show))
    }

    return (
        <EmploymentTypeBadgeFilter
            showEmploymentTypes={showEmploymentTypes}
            onChange={handleChange}
        />
    )
}

export default ConnectedEmploymentTypeBadgeFilter
